import { create } from "zustand";

interface GtmState {
  readonly initiated: boolean;
  setInitiated: (initiated: boolean) => void;
}

export const useGtmStore = create<GtmState>()((set) => ({
  initiated: false,
  setInitiated: (initiated) => set({ initiated }),
}));
